<section class="default-section">
  <article class="default-card">
    <h1 class="jumbotron-headline">Seite nicht gefunden</h1>
    <p class="jumbotron-lead">
      Die angeforderte Seite <b>{{ currentUrl }}</b> wurde nicht gefunden. Fehler 404.
    </p>
    <p class="jumbotron-lead">
      <app-mat-icon-button [routerLink]="['/']" label="Zur Startseite gehen"></app-mat-icon-button>
    </p>
  </article>
</section>
